<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="jumbotron text-center">
        <h1 class="display-3">Thank You!</h1>
        <p class="lead"><strong>Please check your email</strong> for order confirmation.</p>
        <hr>
        <p>

        <p>Order Id : <strong>{{orderId}}</strong></p>
      </div>

      <table class="table table-striped">
        <thead>
        <tr>
          <th>Image</th>
          <th>Title</th>
          <th>Price</th>
          <th>Quantity</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let p of products">
          <td>
            <img [src]="p.image" alt="{{p.title}}" class="img-thumbnail" width="100px">
          </td>
          <td>{{p.title}}</td>
          <td>{{p.price | currency:'EUR'}}</td>
          <td>{{p.quantityOrdered}}</td>
        </tr>

        <tr class="border-0">
          <td style="border: none;"></td>
          <td></td>
          <td><h3><b>TOTAL</b></h3></td>
          <td><h3><b>{{cartTotal | currency:'EUR'}}</b></h3></td>

        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


